module.exports = __webpack_public_path__ + "assets/Power.11e90193.svg";